import { Translatable } from "@icc/shared/helpers";

export class InspectionHatch {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Kod do wydruków */
    printCode: string;
    /** Zdjęcie */
    img: string;
    /** Opis */
    description: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Masa za metr bieżący [kg] */
    weight?: number;
    /** Identyfikator zestawu grup kolorów */
    colorGroupSetId?: number | null;
    /** Możliwość wyboru w konfiguratorze */
    choiceInConfigurator?: boolean;
    /** Umiejscowienie klapy rewizyjnej */
    inspectionHatchLocation?: 'front' | 'bottom';
}